module.exports = __webpack_public_path__ + "media/images/sp/special_reports/separator_suns-9098e2a09a6c7aff8049a88772e6437c.jpg";